// extracted by mini-css-extract-plugin
export default {"globalNotificationPopupWrapper":"styles_globalNotificationPopupWrapper__KGca2"};